'use es6';

import I18n from 'I18n';
import React from 'react';
import UIStepperButton from './UIStepperButton';
import omit from '../utils/underscore/omit';
export default function UINextButton(props) {
  return React.createElement(UIStepperButton, Object.assign({
    "aria-label": I18n.text('salesUI.UINextButton.label'),
    iconName: "next"
  }, props));
}
var EXCLUDED_STEPPER_BUTTON_PROP_NAMES = ['iconName', 'aria-label'];
UINextButton.propTypes = Object.assign({}, omit(UIStepperButton.propTypes, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
UINextButton.defaultProps = Object.assign({}, omit(UIStepperButton.defaultProps, EXCLUDED_STEPPER_BUTTON_PROP_NAMES));
UINextButton.displayName = 'UINextButton';